"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function SignUpForm(_a) {
    var handleChange = _a.handleChange;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("label", { htmlFor: "username" },
            "Username:",
            react_1.default.createElement("input", { id: "username", name: "username", onChange: handleChange, type: "text" })),
        react_1.default.createElement("label", { htmlFor: "email" },
            "Email:",
            react_1.default.createElement("input", { id: "email", name: "email", onChange: handleChange, type: "text" })),
        react_1.default.createElement("label", { htmlFor: "password" },
            "Password:",
            react_1.default.createElement("input", { id: "password", name: "password", onChange: handleChange, type: "password" })),
        react_1.default.createElement("button", { className: "login-button", name: "Submit", type: "submit" }, "Submit")));
}
exports.default = SignUpForm;
